module.exports = "/video-roulette/img/red-ball.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/video-roulette/img/red-ball.png
// module id = 2437
// module chunks = 10